import {
  ConfigProvider,
  Layout,
  theme
} from "antd";
import React, { useState, useEffect } from "react";
import { themeState } from '../utils/atoms/index'
// import { useAuth } from "../utils/Auth/AuthWrapper";
import ContentLayout from "./content";
import SiderLayout from "./sidebar";
import HeaderLayout from "./header";
import FooterLayout from "./footer";
import { useRecoilState } from "recoil";
import decode from 'jwt-decode';
import { SocketWrapper } from "../utils/socketio/SocketWrapper";
import { useLocation } from "react-router-dom";

const DefaultLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  // const auth = useAuth();
  // const [locale, setLocale] = useRecoilState(localeState);
  const [themeMode, setThemeMode] = useRecoilState(themeState);
  const path = useLocation()
  const forgotpath = path.pathname.split("/")
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };


  useEffect(() => {
    checkToken();

    const storedTheme = localStorage.getItem('themeMode') || 'light';
    setThemeMode(storedTheme);
  }, [setThemeMode]);


  const checkToken = () => {
    const token = localStorage.getItem("stt");
    if (token) {
      const decodedToken = decode(token);
      // [OLD CODE] เดิมตั้งใจเช็ค token หมดอายุ แต่ถูก comment ไว้ และ tokenExpiration ไม่ได้ใช้
      // const tokenExpiration = decodedToken.exp * 1000; // Convert to milliseconds
      // if (Date.now() >= tokenExpiration) {
      if (decodedToken.user_id == null) {
        setIsTokenExpired(true);
      }
    } else {
      setIsTokenExpired(true);
    }
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: themeMode === 'light' ? theme.defaultAlgorithm : theme.darkAlgorithm,
        token: {
          colorPrimary: '#00215E',
        },
        components: {
          Layout: {
            colorBgBody: themeMode === 'dark' ? '#000000' : '#F3F3F1',
            // colorBgBody: '#rgba(164, 163, 163, 1)',
          },
          Typography: {
            colorTextHeading: themeMode === 'dark' ? '#ffffff' : '#00215E',
            fontSizeHeading1: 34,
          },
          Badge: {
            fontSize: 16
          },
          Menu: {
            colorItemHover: '#00215E',
            colorItemSelected: '#00215E',
            colorItemActiveBg: '#00215E',
          },
          Breadcrumb: {
            fontSize: 28,
            fontFamily: "IBM Plex Sans Thai",
            colorText : '#00215E'
          },
          Tabs: {
            fontSize : 16
          }
        }
      }}
    >
        <SocketWrapper>

      {/* test new layer */}
      <Layout style={{ minHeight: "100vh", display: 'flex', }}>
        <HeaderLayout isTokenExpired={isTokenExpired} />
        <Layout>
          {/* === OLD: SiderLayout as separate horizontal nav bar below header ===
          {forgotpath[1]+"/"+forgotpath[2]  == "user/confirmpassword" || path.pathname  == "/user/forgot/reset" ?
          <></>:
          <SiderLayout collapsed={collapsed} setCollapsed={setCollapsed} isTokenExpired={isTokenExpired} />}
          === END OLD === */}
          <Layout style={{
            marginTop: '70px', // ลดจาก 128px → 70px เพราะ nav ย้ายเข้า header แล้ว
            // transition: 'margin-left 0.2s',
          }}>
            <ContentLayout style={{ padding: '24px', minHeight: 'calc(100vh - 64px)' }} collapsed={collapsed} />
            <FooterLayout collapsed={collapsed} />
          </Layout>
        </Layout>
      </Layout>
      </SocketWrapper>
    </ConfigProvider>
  );
};
export default DefaultLayout;
